import { render, staticRenderFns } from "./ContratoPrecos.vue?vue&type=template&id=44c85c0c&"
import script from "./ContratoPrecos.vue?vue&type=script&lang=js&"
export * from "./ContratoPrecos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports